<template>
    <div class="row">
        <div class="col-12">
            <string-appender :texts="[
                'AgeSA\'ya bağlanılıyor...',
                'Giriş yapılıyor...',
                'SMS bekleniyor...',
            ]" :done="!p1Loading"></string-appender>
        </div>
        <template v-if="p1Result != null && !codeSended">
            <div class="col-12 mt-75">
                <template v-if="$safe(p1Result,'Success') == true">
                    <div class="border rounded p-75">
                        <div class="row">
                            <div class="col-12 mb-1 text-center">
                                SMS kodunu giriniz.
                            </div>
                            <div class="col-12 mb-1">
                                <v-pin-code v-model="code"></v-pin-code>
                            </div>
                            <div class="col-12 text-right">
                                <v-executer :disabled="!codeIsReady" :loading="p2Loading" :action="p2" text="Devam Et"></v-executer>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger mb-0">
                        <div class="alert-body">
                            {{ $safe(p1Result,'Message') }}
                        </div>
                    </div>
                </template>
            </div>
            <div v-if="$safe(p1Result,'Success') == false" class="col-12 mt-75 text-right">
                <button class="btn btn-danger mr-50" v-on:click="$emit('done','close')">Vazgeç</button>
                <button class="btn btn-primary" v-on:click="$emit('done','retry')">Yeniden Dene</button>
            </div>
        </template>
        <template v-if="codeSended && $safe(p1Result,'Success') == true">
            <div class="col-12 mt-25">
                <string-appender :texts="[
                    'SMS gönderildi.',
                ]" done></string-appender>
            </div>
            <div class="col-12 mt-25">
                <string-appender :texts="[
                    'Verilere erişiliyor...',
                    'Dosya indiliyor...',
                    'Dosya işleniyor...',
                    'Dosya içeriği TMS\'ye yazılıyor...'
                ]" :duration="1500" :done="!p2Loading"></string-appender>
            </div>
            <template v-if="p2Result != null">
                <div class="col-12 mt-25">
                    <string-appender :texts="[
                        'Tüm işlemler tamamlandı.'
                    ]" done></string-appender>
                </div>
                <div class="col-12 mt-75">
                    <template v-if="$safe(p2Result,'Success') == true">
                        <div class="alert alert-success mb-0">
                            <div class="alert-body">
                                {{ $safe(p2Result,'Message') }}
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="alert alert-danger mb-0">
                            <div class="alert-body">
                                {{ $safe(p2Result,'Message') }}
                            </div>
                        </div>
                    </template>
                </div>
                <div v-if="$safe(p2Result,'Success') == true" class="col-12 mt-75 text-right">
                    <button class="btn btn-primary" v-on:click="$emit('done','refresh')">Tamamla</button>
                </div>
                <div v-else class="col-12 mt-75 text-right">
                    <button class="btn btn-danger mr-50" v-on:click="$emit('done','close')">Vazgeç</button>
                    <button class="btn btn-primary" v-on:click="$emit('done','retry')">Yeniden Dene</button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import StringAppender from '@/components/StringAppender.vue';
import EmployeeOperations from '@/api/employee-operations'
import VPinCode from '@/components/VPinCode.vue'

export default {
    props:{
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    components:{
        StringAppender,
        VPinCode
    },
    mounted(){
        this.p1()
    },
    data(){
        return {
            code:'',
            p1Result:null,
            p1Loading:false,
            p2Result:null,
            p2Loading:false,
            codeSended:false,
        }
    },
    methods:{
        p1(){
            this.p1Loading = true
            this.codeSended = false
            this.p1Result = null
            EmployeeOperations.BESRobotP1().then(res => { 
                this.p1Result = res.data 
                this.p1Loading = false
            }).catch(err => {
                this.p1Loading = false
            })
        },
        p2(){
            this.p2Loading = true
            this.p2Result = null
            setTimeout(()=>{
                this.codeSended = true
            },1000)
            EmployeeOperations.BESRobotP2(
                this.code,
                this.filter.Month,
                this.filter.Year
            ).then(res => { 
                this.p2Result = res.data 
                this.p2Loading = false
            }).catch(err => {
                this.p2Loading = false
            })
        }
    },
    computed:{
        codeIsReady(){
            return (this.code || '').length == 6
        }
    }
}
</script>